
import React from "react";

interface DirectorSectionHeaderProps {
  directorName: string;
}

const DirectorSectionHeader: React.FC<DirectorSectionHeaderProps> = ({ directorName }) => {
  // Header styling with reduced vertical spacing
  const headerClassName = "py-2 md:py-3 mb-2 md:mb-3";
  
  // Title styling without scroll effects - removed bg color
  const titleClassName = "text-2xl font-bold tracking-tight relative z-10 text-reel-celticBlue";
  
  return (
    <div className={headerClassName}>
      <h2 className={titleClassName}>
        {directorName}
      </h2>
    </div>
  );
};

export default DirectorSectionHeader;
